import React from "react";
import { useSelector } from "react-redux";
import { RecetasDigitalesCard } from "../UI/RecetasDigitalesCard";
import { RecetasDigitalesDetalleTipoForm } from "./RecetasDigitalesDetalleTipoForm";
import { RecetasDigitalesDetalleOrdenInformation } from "./RecetasDigitalesDetalleOrdenInformation";
import { OBRAS_SOCIALES } from "../../../utils/constants";

export const RecetasDigitalesDetalleOrden = (props) => {
  const { showForm, recetaSeleccionada = {}} = useSelector(
    (state) => state.recetasDigitales
  );

  let idTipoReceta;
  let idObraSocial;

  if (recetaSeleccionada != null) {
    idTipoReceta = recetaSeleccionada?.idTipoReceta;
    idObraSocial = recetaSeleccionada?.idAfiliado ? OBRAS_SOCIALES.OSPEDYC : recetaSeleccionada.afiliadoExterno?.idObraSocial;
  } else {
    idObraSocial = props.idObraSocial;
  }

  return (
    <RecetasDigitalesCard width={"55%"}>
      {showForm ? (
        <RecetasDigitalesDetalleTipoForm 
          idTipoReceta={idTipoReceta}
          idObraSocial={idObraSocial}
        />
      ) : (
        <RecetasDigitalesDetalleOrdenInformation
          idTipoReceta={idTipoReceta}
          idObraSocial={idObraSocial}
        />
      )}
    </RecetasDigitalesCard>
  );
};
